import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=a2ec0076&scoped=true&"
import script from "./modal.vue?vue&type=script&lang=js&"
export * from "./modal.vue?vue&type=script&lang=js&"
import style0 from "./modal.vue?vue&type=style&index=0&id=a2ec0076&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ec0076",
  null
  
)

export default component.exports